import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Form, Field } from 'react-final-form';
import { useLocaleFormat } from '@/shared/hooks';
import { Box } from '@/shared/ui/box';
import { Button } from '@/shared/ui/form/button';
import { Image } from '@/shared/ui/image';
import { Condition } from '@/shared/ui/condition';
import { FormField } from '@/shared/ui/form/form-field';
import { CheckboxField } from '@/shared/ui/form/checkbox-field';
import { Link } from '@/shared/ui/link';
import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import {
  BodyTextBoldSecondary,
  BoldHeadingSenary,
  BodyTextRegularSecondary,
} from '@/shared/ui/typography';
import { useAuth } from '@/features/auth-managment/model/auth-context';
import { useCurrentLocale } from '@locales/client';
import {
  FormWrapper,
  FormTypeSection,
  ResetPasswordBlock,
  ButtonContinue,
  FormTypeSections,
  FormContainer,
  FormChangeSections,
  BoxForSelectLanguage,
} from '@/features/auth-managment/styles';
import { WelcomBannerSignUp } from './ui/welcom-banner-signup';
import { GroupAuthVariant } from './ui/group-auth-variant';
import { Wrapper } from '../../../wallet-managment/styles';
import { SelectLanguage } from '@/features/select-language';
import { SelectCurrency } from '@/features/select-currency/ui/select-currency';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { FullForm } from '@/features/wallet-managment/ui/fiat-form/ui/full-form';
import { useDebounce } from '@/shared/hooks';
import {
  CloseIconImage,
  StyledAlertDialogOverlay,
  StyledAlertDialogContent,
} from '@/features/auth-managment/styles';
import { CardBonuse } from '@/features/news-managment/ui/prepared-bonuses/components/card-bonuse';
import { TitlePrepared } from '@/features/news-managment/ui/prepared-bonuses/components/title-prepared';

import { WrapperBonuse, WrapperCardBonuse } from './styles';
import {
  BodyTextMediumC,
  BodyTextMediumB,
  BodyTextRegularD,
} from '@/shared/ui/typography2';

export const PreparedBonuses = () => {
  const formatUrl = useLocaleFormat();
  // const { addQueryParam } = useConfirmDataPrompt();/
  const locale = useCurrentLocale();

  return (
    <WrapperBonuse>
      <TitlePrepared />
      <WrapperCardBonuse>
        <CardBonuse></CardBonuse>
        <CardBonuse></CardBonuse>
        <CardBonuse></CardBonuse>
        <CardBonuse></CardBonuse>
      </WrapperCardBonuse>
    </WrapperBonuse>
  );
};
